import {
  Card,
  CardMedia,
  CardContent,
  List,
  ListItem,
  Typography,
  Grid,
  Skeleton,
  Button,
  Stack,
  Box,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  ImageList,
  ImageListItem,
} from "@mui/material";
import SendIcon from "@mui/icons-material/Send";
import { ToastContainer, toast, Zoom } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  getProfileDetails,
  updateViewedProfile,
  startChatConversation,
  getMembership,
  getMobileNumber,
} from "../../../api/api";
import { ls } from "../../../utils/localStorage";
import moment from "moment";
import "./style.scss";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
const ViewProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [profileDetails, setProfileDetails] = useState(null);
  const [dropdownOptions, setDropdownOptions] = useState(null);
  const [loading, setLoading] = useState(true);
  const [chatLoading, setChatLoading] = useState(false);
  const [membership, setMembership] = useState(false);
  const [open, setOpen] = useState(false);

  const checkSubscription = async () => {
    try {
      const response = await getMembership();
      if (response && response.status >= 200 && response.status <= 300) {
        setMembership(response?.data?.is_membership);
      }
    } catch (error) {
      setMembership(false);
      toast.error(
        error?.response?.data?.error?.message || "Something wend wrong",
        {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
          transition: Zoom,
        },
      );
    }
  };

  useEffect(() => {
    fetchDropdownsValues();
    getProfile();
    getMembership();
  }, []);

  const fetchDropdownsValues = async () => {
    const data = JSON.parse(ls.getItem("dropdown_values_for_reference"));
    setDropdownOptions(data);
  };

  const getProfile = async () => {
    try {
      const response = await getProfileDetails(id);
      if (response) {
        setProfileDetails({
          ...response.data,
          dob: moment(response.data.dob).format("MMM DD yyyy"),
        });
        setLoading(false);
        // updateProfilViewed(response.data.id);
      }
    } catch (error) {
      toast.error(
        error?.message
          ? error.message
          : error?.response?.data?.error?.message || "Something went wrong",
        {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
          transition: Zoom,
        },
      );
      setLoading(false);
    }
  };

  const updateProfilViewed = async (profileId) => {
    try {
      let data = {
        profile_id: profileId,
      };
      const response = await updateViewedProfile(data);
      if (response && response.status >= 200 && response.status <= 300) {
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
          transition: Zoom,
        });
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.error?.message || "Something wend wrong",
        {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
          transition: Zoom,
        },
      );
    }
  };

  const handleClickShowPhone = () => {
    setLoading(true);

    getMobileNumber(profileDetails?.id)
      .then((response) => {
        console.log("response", response);
        setLoading(false);
        setProfileDetails({
          ...profileDetails,
          mobileno: response?.data?.mobileno,
        });
        const message = `Remaining mobile reveals: ${response?.data?.remaining}/${response?.data?.limit}`;
        toast.success(message, {
          position: "top-right",
          autoClose: 5000,
          theme: "colored",
          transition: Zoom,
        });
      })
      .catch((error) => {
        setLoading(false);
        toast.error(
          error?.response?.data?.error?.message || "Something wend wrong",
          {
            position: "top-right",
            autoClose: 1500,
            theme: "colored",
            transition: Zoom,
          },
        );
      });
  };

  const startchat = async (id) => {
    setChatLoading(true);
    try {
      const response = await startChatConversation(id);
      navigate("/auth/chat", {
        state: {
          conversation: {
            conversation_id: response.data.conversationId,
            recipient: response.data.participant,
            message: "",
            latest_time: null,
          },
        },
      });
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Unable to start conversation",
        {
          position: "top-right",
          autoClose: 1500,
          theme: "colored",
          transition: Zoom,
        },
      );
    } finally {
      setChatLoading(false);
    }
  };

  const skeletonLoader = () => {
    return (
      <Card className="wishlist-card" elevation={8}>
        <Skeleton variant="rectangular" height={158} />
        <Skeleton />
        <Skeleton width="60%" />
      </Card>
    );
  };

  const skeletonProfileLoader = () => {
    return (
      <Card className="wishlist-card" elevation={8}>
        <CardContent>
          <div className="row">
            <div className="col-sm-6">
              <Card className="wishlist-card" elevation={8}>
                <Skeleton variant="rectangular" height={158} />
                <Skeleton />
                <Skeleton width="60%" />
              </Card>
            </div>

            <div className="col-sm-6">
              <List>
                {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
                  <ListItem className="row">
                    <div className="col-sm-6">
                      <Skeleton />
                    </div>
                    <div className="col-sm-6">
                      <Skeleton />
                    </div>
                  </ListItem>
                ))}
              </List>
            </div>
            <div className="col-sm-6">
              <List>
                {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
                  <ListItem className="row">
                    <div className="col-sm-6">
                      <Skeleton />
                    </div>
                    <div className="col-sm-6">
                      <Skeleton />
                    </div>
                  </ListItem>
                ))}
              </List>
            </div>

            <div className="col-sm-6">
              <List>
                {[1, 2, 3, 4, 5, 6, 7, 8].map((n) => (
                  <ListItem className="row">
                    <div className="col-sm-6">
                      <Skeleton />
                    </div>
                    <div className="col-sm-6">
                      <Skeleton />
                    </div>
                  </ListItem>
                ))}
              </List>
            </div>
          </div>
        </CardContent>
      </Card>
    );
  };
  const itemData = [
    { img: "https://picsum.photos/id/237/200/300", title: "Breakfast" },
    { img: "https://picsum.photos/id/238/200/300", title: "Burger" },
    { img: "https://picsum.photos/id/239/200/300", title: "Camera" },
    { img: "https://picsum.photos/id/240/200/300", title: "Coffee" },
    { img: "https://picsum.photos/id/241/200/300", title: "Car" },
  ];
  return (
    <div className="container-fluid view_profile">
      <div className="vp-flex">
        {/* <div className="profile_image">
          <div className="profile_basic_details">
            <h1>Profile</h1>
            {loading ? (
              skeletonLoader()
            ) : (
              <Card elevation={8}>
                <CardMedia
                  component="img"
                  height="250"
                  image={
                    profileDetails?.image !== "" &&
                    profileDetails?.image !== undefined &&
                    profileDetails?.image !== null
                      ? // process.env.REACT_APP_BASE_URL + "/" +
                        profileDetails?.image
                      : ""
                  }
                  alt="green iguana"
                />
                <CardContent>
                  <Typography gutterBottom variant="h4" component="div">
                    {profileDetails?.name || "-"}
                  </Typography>

                  <Typography sx={{ fontSize: 14 }} color="text.secondary">
                    {profileDetails?.about_me || "-"}
                  </Typography>
                </CardContent>
              </Card>
            )}
          </div>
        </div> */}
        <div className="profile_details">
          {loading ? (
            skeletonProfileLoader()
          ) : (
            <Card elevation={8}>
              <CardContent>
                <div className="row">
                  <div className="row">
                    <div className="col-sm-12">
                      <Typography gutterBottom variant="h5" component="div">
                        Personal Information
                      </Typography>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <List>
                      <Card
                        elevation={8}
                        raised
                        sx={{
                          maxWidth: "90%",
                          maxHeight: "20%",
                          margin: "0 auto",
                          padding: "0.1em",
                        }}
                      >
                        <CardMedia
                          component="img"
                          height="300"
                          sx={{
                            padding: "1em 1em 0 1em",
                            objectFit: "contain",
                          }}
                          image={
                            profileDetails?.image !== "" &&
                            profileDetails?.image !== undefined &&
                            profileDetails?.image !== null
                              ? // process.env.REACT_APP_BASE_URL + "/" +
                                profileDetails?.image
                              : ""
                          }
                          alt="green iguana"
                        />
                        <CardContent>
                          <Typography gutterBottom variant="h4" component="div">
                            {profileDetails?.name || "-"}
                          </Typography>

                          <Typography
                            sx={{ fontSize: 14 }}
                            color="text.secondary"
                          >
                            {profileDetails?.about_me || "-"}
                          </Typography>

                          <Box display={"flex"} alignItems="center" gap={1}>
                            <Typography>
                              Mobile: {profileDetails?.mobileno}
                            </Typography>
                            {profileDetails?.mobileno?.includes("x") && (
                              <Tooltip title="View Phone">
                                {" "}
                                <IconButton onClick={handleClickShowPhone}>
                                  <VisibilityOffIcon />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Box>
                        </CardContent>
                      </Card>
                    </List>
                  </div>
                  <div className="col-sm-6">
                    <List>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Name:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.name || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Gender:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.gender || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Physical Status:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.physical_status || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Height (In CM):
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.height || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Marital Status:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.marital_status || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Smoking Habits:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.smoking_habit || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Drinking Habits:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.drinking_habit || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Surname:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.surname || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Date Of Birth:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.dob || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Body Type:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.body_type || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Weight (In KG):
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.weight || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Mother Tounge:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.mother_tongue || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Eating Habits:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.eating_habit || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-10">
                          <Button
                            onClick={() => startchat(profileDetails?.id)}
                            variant="contained"
                            endIcon={<SendIcon />}
                            disabled={chatLoading}
                          >
                            Chat now
                          </Button>
                        </div>
                      </ListItem>
                    </List>
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-sm-6">
                    <div className="row">
                      <div className="col-sm-12">
                        <Typography gutterBottom variant="h5" component="div">
                          Religion Information
                        </Typography>
                      </div>
                    </div>
                    <List>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Religion:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.religion || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Caste:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.caste || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                    </List>
                  </div>
                  <div className="col-sm-6">
                    <div className="row">
                      <div className="col-sm-12">
                        <Typography gutterBottom variant="h5" component="div">
                          Horoscopic Information
                        </Typography>
                      </div>
                    </div>
                    <List>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Nakshtram:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.star || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Raasi:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.zodiac || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Time of Birth:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.time_of_birth || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                    </List>
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-sm-6">
                    <div className="row">
                      <div className="col-sm-12">
                        <Typography gutterBottom variant="h5" component="div">
                          Location Information
                        </Typography>
                      </div>
                    </div>
                    <List>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Town/City:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.city || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            District:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.district || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            State:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.state || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Country:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.country || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Citizenship:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.citizen || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                    </List>
                  </div>
                  <div className="col-sm-6">
                    <div className="row">
                      <div className="col-sm-12">
                        <Typography gutterBottom variant="h5" component="div">
                          Professional Information
                        </Typography>
                      </div>
                    </div>
                    <List>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Higher Qualification:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.education || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Employed In:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.employeed_in || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Occupation:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.occupation || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Country:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.country || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Annual Income:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.salary || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                    </List>
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-sm-12">
                    <Typography gutterBottom variant="h5" component="div">
                      Family Information
                    </Typography>
                  </div>
                  <div className="col-sm-6">
                    <List>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Family Type:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.family_type || "-"}
                          </Typography>
                        </div>
                      </ListItem>

                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Fathers Occupation:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.fathers_occupation || "-"}
                          </Typography>
                        </div>
                      </ListItem>

                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Number of Brothers:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.no_of_brothers || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                    </List>
                  </div>
                  <div className="col-sm-6">
                    <List>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Family Status:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.family_status || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Mothers Occupation:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.mothers_occupation || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Number of Sisters:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.no_of_sisters || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                    </List>
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-sm-12">
                    <Typography gutterBottom variant="h5" component="div">
                      Other Information
                    </Typography>
                  </div>
                  <div className="col-sm-6">
                    <List>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Hobbies:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.hobbies || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                    </List>
                  </div>
                  <div className="col-sm-6">
                    <List>
                      <ListItem className="row">
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="text.secondary"
                            component="div"
                          >
                            Interest:
                          </Typography>
                        </div>
                        <div className="col-sm-6">
                          <Typography
                            variant="subtitle1"
                            color="primary"
                            component="div"
                          >
                            {profileDetails?.interests || "-"}
                          </Typography>
                        </div>
                      </ListItem>
                    </List>
                  </div>
                </div>
                <br />
                <div className="row">
                  <div className="col-sm-12">
                    <Typography gutterBottom variant="h5" component="div">
                      Other Images
                    </Typography>
                  </div>
                  <ImageList
                    sx={{
                      gridAutoFlow: "column",
                      gridTemplateColumns:
                        "repeat(auto-fill, minmax(250px, 1fr)) !important",
                      gridAutoColumns: "minmax(250px, 1fr)",
                      overflowX: "auto",
                      px: 1,
                    }}
                    rowHeight={280}
                    gap={8}
                  >
                    {/* {itemData.map((item) => (
                      <ImageListItem key={item.img}>
                        <img
                          src={`${item.img}?w=200&h=350&fit=crop&auto=format`}
                          alt={item.title}
                          loading="lazy"
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "fill",
                          }}
                        />
                      </ImageListItem>
                    ))} */}
                    {profileDetails?.images.length &&
                      profileDetails?.images.map((item) => (
                        <ImageListItem key={item}>
                          <img
                            src={`${item}?w=250&h=280&fit=crop&auto=format`}
                            alt={item}
                            loading="lazy"
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "fill",
                            }}
                          />
                        </ImageListItem>
                      ))}
                  </ImageList>
                  {/* <div className="row other_images">
                    {profileDetails?.images.length ? (
                      profileDetails?.images.map((img, i) => (
                        <div className="col-sm-6">
                          <Card style={{ marginBottom: "1rem" }} elevation={6}>
                            <CardMedia
                              component="img"
                              height="300"
                              image={
                                img !== "" && img !== undefined && img !== null
                                  ? // process.env.REACT_APP_BASE_URL + "/" +
                                    img
                                  : ""
                              }
                              alt="green iguana"
                            />
                          </Card>
                        </div>
                      ))
                    ) : (
                      <div className="col-sm-6">
                        <Typography
                          variant="subtitle1"
                          color="text.secondary"
                          component="div"
                        >
                          No images found
                        </Typography>
                      </div>
                    )}
                  </div> */}
                </div>
              </CardContent>
            </Card>
          )}
        </div>
      </div>

      <ToastContainer />
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          {" "}
          You need to buy a membership plan to view Phone.
        </DialogContent>
        <Box display={"flex"} justifyContent="center" mb={2}>
          <Button
            onClick={() => navigate("/auth/subscribe")}
            variant="contained"
            color="primary"
            sx={{
              color: "#fff",
            }}
          >
            Go to Membership Plans
          </Button>
        </Box>
      </Dialog>
    </div>
  );
};
export default ViewProfile;
